export default "__VITE_ASSET__DraHPdjH__"